import { Link } from "react-router-dom";
import { CrossIcon } from "@/components/CrossIcon";
import { Mail } from "lucide-react";
import { ContactForm } from "@/components/ContactForm";

export const Footer = () => (
  <footer className="bg-ink-deep text-parchment/80 mt-24">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-gold text-ink">
            <CrossIcon className="w-3.5 h-3.5" />
          </span>
          <span className="font-serif text-2xl font-600 text-parchment">Brother's Immanuel</span>
        </div>
        <p className="text-sm leading-relaxed text-parchment/60 max-w-xs">
          A gospel-centered ministry preaching and teaching the Word of God the Father and of
          Jesus Christ, our risen Lord.
        </p>
        <a href="mailto:info@brothersimmanuel.ca" data-testid="footer-contact-email"
          className="inline-flex items-center gap-2 mt-5 text-sm text-gold hover:text-parchment transition-colors">
          <Mail className="w-4 h-4" /> info@brothersimmanuel.ca
        </a>
        <ContactForm />
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">Explore</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
          <li><Link to="/fellowship" className="hover:text-gold transition-colors">Fellowship Hall</Link></li>
          <li><Link to="/read" className="hover:text-gold transition-colors">Read the Bible</Link></li>
          <li><Link to="/word-study" className="hover:text-gold transition-colors">Bible Word Study</Link></li>
          <li><Link to="/media" className="hover:text-gold transition-colors">Gospel Media</Link></li>
          <li><Link to="/bible-maps" data-testid="footer-map-gallery-link" className="hover:text-gold transition-colors">Bible Map Gallery</Link></li>
          <li><a href="https://shiftyourphone.com/content-filter/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Shift — Block Explicit Content</a></li>
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">Our Confession</h4>
        <p className="font-serif text-xl italic leading-snug text-parchment/90">
          "For God so loved the world, that he gave his one and only Son, that whoever believes in him
          should not perish, but have eternal life."
        </p>
        <p className="text-xs text-parchment/50 mt-2 font-mono">— John 3:16</p>
      </div>
    </div>
    <div className="border-t border-parchment/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-parchment/40 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Brother's Immanuel Ministry. Soli Deo Gloria.</span>
        <span className="font-mono">Immanuel — God with us.</span>
      </div>
    </div>
  </footer>
);
